import React, { useEffect } from 'react';
import { Route, Redirect, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { LOGIN_SUCCESS, SET_PAGES } from "../../actions/types";
import { CoreService, PrivilegeManagerService } from "../../services";

const SecureRoute =
    ({ component: Component, layout: Layout, path: Path, ...rest }) => {
        const history = useHistory();
        const userStore = useSelector((state) => state.authentification);
        const pages = useSelector((state) => state.privilegeManager.pages);

        const isTransporter = JSON.parse(localStorage.getItem('user'))?.isTransporter === 'T';
        const appliedPermissions = useSelector((state) => state.privilegeManager.appliedPermissions)

        const dispatch = useDispatch();
        let isLoginPath = Path === "/login";
        let isUnauthorized = Path === "/unauthorized" || Path === "/logout";

        /*If the user reload the page*/
        useEffect(() => {
            if (!isUnauthorized) {
                if (userStore && !userStore.isLoggedIn && !isLoginPath) {
                    CoreService.isLogged().then((response) => {
                        const data = response.data;
                        if (data.isLoggedIn === false) {
                            return history.push('/login')
                        }
                        else {
                            dispatch({
                                type: LOGIN_SUCCESS,
                                payload: data,
                            });
                        }
                    });
                }
            }
        }, [dispatch]);

        useEffect(() => {
            if (!isUnauthorized) {
                if ((!pages || pages.length === 0) && userStore.isLoggedIn) {
                    PrivilegeManagerService.getPages().then(
                        (response) => {
                            dispatch({
                                type: SET_PAGES,
                                payload: response,
                            });
                        }
                    );
                }
            }
        });

        useEffect(() => {
            if (!isUnauthorized) {
                if (userStore.isLoggedIn && isLoginPath) {
                    if (userStore.user.defaultPage) {
                        return history.push(userStore.user.defaultPage)
                    } else {
                        return history.push('/');
                    }
                }
                if (!userStore.isLoggedIn && !isLoginPath) {
                    return history.push('/login');
                }
                if (pages && pages.length > 0) {
                    let exempt = ['/login', '/', '/access-denied']
                    let urlAllow = isTransporter ? pages.map(p => p.pagId[0] === '6' ? `${p.pagId}-${p.pagUrl}` : '') : pages.map(p => `${p.pagId}-${p.pagUrl}`)
                    let shouldAllow = appliedPermissions.findIndex(x => urlAllow.includes(x.key + '-' + Path) && x.value.split('')[0] === "1")
                    if (shouldAllow < 0 && !exempt.includes(Path)) {
                        return history.push('/access-denied')
                    }
                }
            }
        });

        return <Route {...rest} render={props => (
            <Layout>
                <Component {...props} />
            </Layout>
        )} />;
    };
export default SecureRoute;